/* eslint-disable no-magic-numbers */
import Constants from "const/Constants";
import Currencies from "const/Currencies";

export default class Money {
  static getCurrencyPrecision(currency) {
    return currency === Currencies.KWD ? "..." : "..";
  }

  static getCurrencySymbol(currency) {
    const languageCodes = [
      ...(window.navigator.languages || []),
      Constants.DEFAULT_NUMBERS_LOCALE
    ];

    return (0).toLocaleString(
      languageCodes,
      {
        style: "currency",
        currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }
    ).replace(/\d/g, "").trim();
  }

  static parseKwdAmount(text) {
    const normalizedValue = `${text || ""}`.replace(/\s+/g, " ").trim();

    if (!normalizedValue) return null;

    const amountToken = (normalizedValue.match(/[-+]?\d[\d.,]*\d|[-+]?\d/g) || []).find((value) => /[.,]/.test(value)) || "";

    if (!amountToken) return null;

    const sign = amountToken.startsWith("-") ? "-" : "";

    const unsignedToken = amountToken.replace(/^[-+]/, "");

    const separatorIndex = Math.max(unsignedToken.lastIndexOf("."), unsignedToken.lastIndexOf(","));

    const fractionPart = unsignedToken.slice(separatorIndex + 1);

    if (separatorIndex <= 0 || fractionPart.length !== 3 || !/^\d+$/.test(fractionPart)) return null;

    const integerPart = unsignedToken.slice(0, separatorIndex).replace(/[.,]/g, "");

    if (!/^\d+$/.test(integerPart)) return null;

    return Number(`${sign}${integerPart}.${fractionPart}`);
  }

  static toMoneyString(money, currency, fractionDigits = Money.getCurrencyPrecision(currency).length) {
    if (isNaN(money) || !money) money = 0;
    if (currency && currency !== "undefined") {
      const languageCodes = [
        ...(window.navigator.languages || []),
        Constants.DEFAULT_NUMBERS_LOCALE
      ];

      try {
        return money.toLocaleString(
          languageCodes,
          {
            currency,
            style: "currency",
            minimumFractionDigits: fractionDigits,
            maximumFractionDigits: fractionDigits
          }
        );
      } catch (error) {
        return `${(money || 0).toFixed(fractionDigits)} ${currency}`;
      }
    }

    return money.toFixed(fractionDigits);
  }

  static toMoneyNumber(number, useRound = true, precision = "..") {
    const mathMethod = useRound ? Math.round : Math.floor;

    const precisionMultiplier = Math.pow(Constants.DECIMALS_MULTIPLIER, precision.length);

    return mathMethod((+number + Number.EPSILON) * precisionMultiplier) / precisionMultiplier;
  }
}
